<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-select v-model="projectId" :size="size" clearable placeholder="请选择项目" @change="chagneProjectData">
          <el-option
            v-for="item in projectData"
            :key="item.proId"
            :label="item.proName"
            :value="item.proId">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">标段：</span>
        <el-select v-model="segmentId" :size="size" clearable placeholder="请选择标段">
          <el-option
            v-for="item in sectionData"
            :key="item.segmentId"
            :label="item.segmentName"
            :value="item.segmentId">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">收货人姓名：</span>
        <el-input v-model="reciverName" :size="size" clearable placeholder="请输入收货人姓名"></el-input>
      </div>
      <div class="header_item">
      <el-button :size="size" icon="el-icon-search" @click="searchConsigneeList(true)">查询</el-button>
      <el-button class="search_btn" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="consigneeList"
        height="100%">
        <el-table-column label="序号" width="55" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="proName" label="项目名称" align="center"></el-table-column>
        <el-table-column prop="segmentName" label="标段" align="center"></el-table-column>
        <el-table-column prop="reciverName" label="收货人姓名" align="center"></el-table-column>
        <el-table-column prop="reciverPhone" label="联系电话" align="center"></el-table-column>
        <el-table-column prop="reciverUnit" label="收货单位" align="center"></el-table-column>
        <el-table-column prop="cityFullName" label="地区" align="center"></el-table-column>
        <el-table-column prop="address" label="详细地址" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增收货人  修改收货人信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增收货人' : '修改收货人信息'"
      :visible.sync="asyncConsignee"
      width="35%">
      <el-form ref="form" :model="formConsignee" :rules="rulesConsignee" label-width="auto" class="rule_form">
        <el-form-item label="项目名称：" prop="proId">
          <el-select v-model="formConsignee.proId" :size="size" clearable placeholder="请选择项目" @change="chagneProjectData">
            <el-option
              v-for="item in projectData"
              :key="item.proId"
              :label="item.proName"
              :value="item.proId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标段：" prop="segmentId">
          <el-select v-model="formConsignee.segmentId" :size="size" clearable placeholder="请选择标段">
            <el-option
              v-for="item in sectionData"
              :key="item.segmentId"
              :label="item.segmentName"
              :value="item.segmentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货人姓名：" prop="reciverName">
          <el-input v-model="formConsignee.reciverName" :size="size" clearable placeholder="请输入收货人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="reciverPhone">
          <el-input v-model="formConsignee.reciverPhone" :size="size" clearable placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="收货单位：" prop="reciverUnit">
          <el-input v-model="formConsignee.reciverUnit" :size="size" clearable placeholder="请输入收货单位"></el-input>
        </el-form-item>
        <el-form-item label="地区：" prop="cityId">
          <el-cascader
            v-model="formConsignee.cityId"
            :size="size"
            clearable
            placeholder="请选择地区"
            :options="areaOptions"
            :props="areaProps">
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" prop="address">
          <el-input v-model="formConsignee.address" :size="size" clearable placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input 
            v-model="formConsignee.remark"
            :size="size"
            type="textarea"
            clearable
            placeholder="请输入备注"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncConsignee = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from "../../pinia/index";
import { changeSize, throttle } from '../../plugins/public';
  export default {
    data() {
      return {
        projectId: '',
        projectData: [],
        segmentId: '',
        sectionData: [],
        reciverName: '',
        size: changeSize(),
        pageNum: 1,
        pageSize: 10,
        total: 1,
        loading: true,
        consigneeList: [], //列表信息
        asyncTitle: true, // true 新增收货人 false 修改收货人信息
        asyncConsignee: false, // 弹窗
        formConsignee: {}, // 表单信息
        rulesConsignee: {
          proId: [{
            required: true,
            message: '请选择项目',
            trigger: ['change', 'blur']
          }],
          segmentId: [{
            required: true,
            message: '请选择标段',
            trigger: ['change', 'blur']
          }],
          reciverName: [{
            required: true,
            message: '请输入收货人姓名',
            trigger: 'blur'
          }],
          reciverPhone: [{
            required: true,
            message: '请输入收货人电话',
            trigger: 'blur'
          },{
            pattern:
              /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }],
          cityId: [{
            required: true,
            message: '请选择城市',
            trigger: ['change', 'blur']
          }],
          reciverUnit: [{
            required: true,
            message: '请输入收货单位',
            trigger: 'blur'
          }],
          address: [{
            required: true,
            message: '请输入详细地址',
            trigger: 'blur'
          }]
        }, // 表单校验规则
        areaOptions: [],
        areaProps: {
          value: 'id',
          label: 'name',
          children: 'childs',
          emitPath: false
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.getAllProjectData();
      that.searchConsigneeList(true);
    },
    methods: {
      // 获取全部项目信息
      async getAllProjectData() {
        const { data } = await this.$api.Engineer.searchProjects({
          pageNum: 1,
          pageSize: 1000000
        });
        this.projectData = data.list;
      },
      // 获取项目下标段信息
      async getAllSegmentData(projectId) {
        const { data } = await this.$api.Engineer.searchSegment({
          proId: projectId,
          pageNum: 1,
          pageSize: 1000000
        });
        this.sectionData = data.list;
      },
      // 获取所有地区信息
      async getAllCityData() {
        const { data } = await this.$api.Basics.GETALLCITYAREADATA();
        this.areaOptions = this.changeCityData(data);
      },
      // 置空最后一级城市
      changeCityData(data) {
        const list = data.map(item => {
          if(item.hasChild) {
            item = {
              id: item.id,
              name: item.name,
              childs: this.changeCityData(item.childs)
            }
          } else {
            item.childs = undefined;
          }
          return item
        });
        return list
      },
      // 查询收货人信息
      searchConsigneeList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.consigneeList = [];
        this.$api.Basics.SEARCHCONSIGNEELIST({
          proId: this.projectId,
          segmentId: this.segmentId,
          reciverName: this.reciverName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.consigneeList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncConsignee = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncConsignee = true;
        this.getAllSegmentData(row.proId).then(() => {
          this.$set(this.formConsignee, 'id', row.id);
          this.$set(this.formConsignee, 'proId', row.proId);
          this.$set(this.formConsignee, 'segmentId', row.segmentId);
          this.$set(this.formConsignee, 'reciverName', row.reciverName);
          this.$set(this.formConsignee, 'reciverPhone', row.reciverPhone);
          this.$set(this.formConsignee, 'reciverUnit', row.reciverUnit);
          this.$set(this.formConsignee, 'cityId', Number(row.cityId));
          this.$set(this.formConsignee, 'address', row.address);
          this.$set(this.formConsignee, 'remark', row.remark);
        })      },
      // 删除备品备件信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该收货人信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Basics.DELETECONSIGNEEINFO({id: row.id})
        .then(res => {
          if(res.success) {
            this.searchConsigneeList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 选择项目获取标段信息
      chagneProjectData(data) {
        this.sectionData = [];
        if(data) {
          this.getAllSegmentData(data)
        }
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formConsignee);
            this.$api.Basics.INSRTCONSIGNEEINFO(params).then((res) => {
              if(res.success) {
                this.asyncConsignee = false;
                this.$message.success('添加成功！');
                this.searchConsigneeList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formConsignee);
            this.$api.Basics.UPDATECONSIGNEEINFO(params).then((res) => {
              if(res.success) {
                this.asyncConsignee = false;
                this.$message.success('修改成功！');
                this.searchConsigneeList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchConsigneeList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchConsigneeList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    },
    watch: {
      asyncConsignee(bol) {
        if(!bol) {
          this.formConsignee = {};
          this.sectionData = [];
          this.$refs.form.resetFields();
        } else {
          this.getAllCityData();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>